export class ListControlsResponse {
    'controls';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controls",
            "baseName": "controls",
            "type": "Array<Control>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListControlsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
